
/*
=============================================================================
auto-generated ***
to refresh you will need to run
npm run build:model
This code was generated by a tool.
¯\_(ツ)_/¯

Changes to this file may cause incorrect behavior and will be lost if
the code is regenerated.
=============================================================================
*/

export type TOptionSetNames = "bcbs_chargetype" |
	"bcbs_emnotificationsendto" |
	"bcbs_stoplosscontractbasis" |
	"bcbs_portalissuestatuschange" |
	"bcbs_sharedsavingscap" |
	"bcbs_categoryset" |
	"bcbs_claimsardefinition" |
	"bcbs_arfeetype" |
	"bcbs_healthoptions" |
	"bcbs_changetypecode" |
	"bcbs_subrogation" |
	"bcbs_subrogationpaymentmethod" |
	"bcbs_pbmtype" |
	"bcbs_pharmacyformulary" |
	"bcbs_stoplossadministrator" |
	"bcbs_stoplossautoreimbursement" |
	"bcbs_yesnooptionset" |
	"bcbs_contractbasis" |
	"bcbs_stoplosscoverage" |
	"bcbs_perlifetimepercontractyear" |
	"bcbs_corridor" |
	"bcbs_monthlyannual" |
	"bcbs_laseredexcluded" |
	"bcbs_producttypecode" |
	"bcbs_frequencycode" |
	"bcbs_valuetypecode" |
	"bcbs_billingmethodcode" |
	"bcbs_paymentmethodforclaimscodes" |
	"bcbs_paymentmethodadminfeescode" |
	"bcbs_adminfeesbillingtypecode" |
	"bcbs_runoutfees" |
	"bcbs_claimsarfees" |
	"bcbs_claimsbillingreportdeliverycode" |
	"bcbs_relationshiptypecode" |
	"bcbs_teamrolecode" |
	"bcbs_status" |
	"bcbs_lineitemtypecode" |
	"bcbs_writeintypecharges" |
	"bcbs_bccratetype" |
	"bcbs_creditbehaviorcode" |
	"bcbs_servicingoffices" |
	"bcbs_requestaccess" |
	"bcbs_fundingtypes" |
	"bcbs_enablebasedoncode" |
	"bcbs_costsharetype" |
	"bcbs_approvalrequiredstate" |
	"bcbs_requestdatautilization" |
	"bcbs_reportscriptingtype" |
	"bcbs_reportfrequency" |
	"bcbs_enrollsubro" |
	"bcbs_grouplitigationfee" |
	"bcbs_enhancedrecoverypercentagerawlings" |
	"bcbs_hearaidchk" |
	"bcbs_excludedservices6" |
	"bcbs_routineeyechk" |
	"bcbs_statuscode" |
	"bcbs_excludedservices10" |
	"bcbs_erisacode" |
	"bcbs_calc_otheritemsservicesooplimit" |
	"bcbs_coverednotcovered" |
	"bcbs_certaindiagexclusion" |
	"bcbs_dentcarechk" |
	"bcbs_asodependentmaternity" |
	"bcbs_aggregateooptype" |
	"bcbs_opportunitybenefittemplatetype" |
	"bcbs_foodsuppliments" |
	"bcbs_prostheticce" |
	"bcbs_hemophilia" |
	"bcbs_issuecategory" |
	"bcbs_groupconfigurationchangetypecode" |
	"bcbs_calc_profservicesptooplimit" |
	"bcbs_calc_inpathoscareooplimit" |
	"bcbs_opportunityproductpreventivebenefitcode" |
	"bcbs_corridorcode" |
	"bcbs_aggregatedeductibletype" |
	"bcbs_posteriorfillingscode" |
	"bcbs_rx_generic_retail_separaterxded" |
	"bcbs_nonstandard_applyto" |
	"bcbs_dependentmaternity" |
	"bcbs_acupchk" |
	"bcbs_grandfathered" |
	"bcbs_copayselectioncode" |
	"bcbs_lob" |
	"bcbs_customerstatuscode" |
	"bcbs_servicescoveredbeforeded" |
	"bcbs_medicaldeductibletypecode" |
	"bcbs_hhdpaggembedcode" |
	"bcbs_rx_integrateonmedicaldeductible" |
	"bcbs_snc_yn" |
	"bcbs_epo_outofnetworkchiro100out" |
	"bcbs_calc_diagserviceslabooplimit" |
	"bcbs_transactiontypecode" |
	"bcbs_medicaldeductibletype" |
	"bcbs_opportunitytypecode" |
	"bcbs_calc_otcdrugsooplimit" |
	"bcbs_minimumessentialcoverage" |
	"bcbs_epo_innetworkchirservices" |
	"bcbs_copaymentmayapply" |
	"bcbs_genericretailtieroption" |
	"bcbs_benefityeartypecode" |
	"bcbs_calchosptype" |
	"bcbs_plan_type" |
	"bcbs_salesstatuscode" |
	"bcbs_pdexclusion" |
	"bcbs_hottexclusion" |
	"bcbs_excludedservices3" |
	"bcbs_routinephyagelimit" |
	"bcbs_calc_profservicesproceduresooplimit" |
	"bcbs_bcbs_privnurschk" |
	"bcbs_usertypecode" |
	"bcbs_complexitycode" |
	"bcbs_calc_profservicesobsetriccareooplimit" |
	"bcbs_agenttypeofbusinesscode" |
	"bcbs_productsatriskcode" |
	"bcbs_growthhormone" |
	"bcbs_outofpockettype" |
	"bcbs_grpconfigservicecenterclaimsprocessing" |
	"bcbs_salestransitionstatuscode" |
	"bcbs_excludedservices5" |
	"bcbs_attributetypecode" |
	"bcbs_tiertypecode" |
	"bcbs_copaycoinsurancetypecode" |
	"bcbs_preferredmailtieroption" |
	"bcbs_dentaldeductibletypecode" |
	"bcbs_accounttypecode" |
	"bcbs_nonpreferredmailtieroption" |
	"bcbs_hcr_accidental_dental" |
	"bcbs_epo_aremhsubenefitscovered" |
	"bcbs_calcrxtype" |
	"bcbs_opportunityproducttype" |
	"bcbs_sbctype" |
	"bcbs_maternity" |
	"bcbs_numtiers" |
	"bcbs_erisa" |
	"bcbs_excludedservices7" |
	"bcbs_calc_profservicesemerdepartmentooplimit" |
	"bcbs_cosmsurchk" |
	"bcbs_calc_presdrugsgenericooplimit" |
	"bcbs_orthognathic" |
	"bcbs_prostheticexclusion" |
	"bcbs_contractbasiscode" |
	"bcbs_ltcchk" |
	"bcbs_rx_nonpreferred_mail_separaterxded" |
	"bcbs_accidentbenefits" |
	"bcbs_net_prov_yn" |
	"bcbs_ispreauthorizationrequiredfordmeprostheti" |
	"bcbs_actionitemtriggercode" |
	"bcbs_excludedservices2" |
	"bcbs_opportunityproductuwstatuscode" |
	"bcbs_rx_preferred_retail_separaterxded" |
	"bcbs_benefitstatus" |
	"bcbs_aso_ded_is_ded" |
	"bcbs_manuallyeditedpdf" |
	"bcbs_calcvisittype" |
	"bcbs_varicoseexclusion" |
	"bcbs_rx_preferred_mail_separaterxded" |
	"bcbs_gcfundingtypecode" |
	"bcbs_epo_drgugsarecoveredunder" |
	"bcbs_idcardorderingoptioncode" |
	"bcbs_pulmonaryexclusion" |
	"bcbs_excludedservices9" |
	"bcbs_coinsurancemayapply" |
	"bcbs_tiercode" |
	"bcbs_sbcconfig_tablocation" |
	"bcbs_epo_orthognathicsurgeriescoveredat" |
	"bcbs_accidentaldentalinjury" |
	"bcbs_opportunityproducttypecode" |
	"bcbs_excludedservices4" |
	"bcbs_calc_presdrugsbrandedooplimit" |
	"bcbs_weightlosschk" |
	"bcbs_epo_chiropracticserviceslimitestoben" |
	"bcbs_deductibleoopfactorcode" |
	"bcbs_opportunitytowinrenewcode" |
	"bcbs_calc_dmeooplimit" |
	"bcbs_calc_diagservicesradooplimit" |
	"bcbs_excludedservices8" |
	"bcbs_calcprevtype" |
	"bcbs_excludedservices1" |
	"bcbs_actionitemfiltercode" |
	"bcbs_calcradtype" |
	"bcbs_quoterequeststatuscode" |
	"bcbs_ispreauthrequired" |
	"bcbs_minimumvaluestandards" |
	"bcbs_spec_cov_rules_std_ben_smoking" |
	"bcbs_generic_incentive_program_options" |
	"bcbs_stoplosstypecode" |
	"bcbs_grouptypecode" |
	"bcbs_rx_nonpreferred_retail_separaterxded" |
	"bcbs_rx_specialty_separaterxded" |
	"bcbs_specialtydrugnetworks" |
	"bcbs_residentialtreatmentcenters" |
	"bcbs_calc_profservicesspecialistooplimit" |
	"bcbs_grandfatheredcode" |
	"bcbs_calc_ambulanceooplimit" |
	"bcbs_opportunityoutcome" |
	"bcbs_rx_generic_mail_separaterxded" |
	"bcbs_calc_prevservicesvaccinesooplimit" |
	"bcbs_calc_profservicesprimcareooplimit" |
	"bcbs_fi_ppocompanionchooseone" |
	"bcbs_ss_ded_ans" |
	"bcbs_sbcstatus" |
	"bcbs_calclabtype" |
	"bcbs_infertchk" |
	"bcbs_immunizationsagelimit" |
	"bcbs_calc_medicalsuppliesooplimit" |
	"bcbs_calcdmetype" |
	"bcbs_ifinandoutofnetworkpaythesameoonbydsa" |
	"bcbs_applicabilitycode" |
	"bcbs_bluecardoption" |
	"bcbs_partnerplanstatuscode" |
	"bcbs_spec_ref_yn" |
	"bcbs_calcobgyntype" |
	"bcbs_ifinandoutofnetworkpaythesameoonbyamb" |
	"bcbs_productvisibilitycode" |
	"bcbs_chirochk" |
	"bcbs_diabetes" |
	"bcbs_calcinputtypes" |
	"bcbs_actionitemtypecode" |
	"bcbs_jeopardycategorycode" |
	"bcbs_sbclog_function" |
	"bcbs_aso_ded_oop_is_oop" |
	"bcbs_grouprole" |
	"bcbs_nonpreferredretailtieroption" |
	"bcbs_hypnotismexclusion" |
	"bcbs_percentordollarcode" |
	"bcbs_calc_otcmedsuppliesooplimit" |
	"bcbs_processstatecode" |
	"bcbs_genericmailtieroption" |
	"bcbs_partnerplancode" |
	"bcbs_glprocessstatecode" |
	"bcbs_deductiblemayapply" |
	"bcbs_calc_otherfacilityservicesooplimit" |
	"bcbs_hiatypecode" |
	"bcbs_activeenrollment" |
	"bcbs_chiro_mon_or_max" |
	"bcbs_barsurchk" |
	"bcbs_calc_emerdepartmentooplimit" |
	"bcbs_employeraccounttype" |
	"bcbs_emiteventorigin" |
	"bcbs_requiredforvalidationcode" |
	"bcbs_cranialexclusion" |
	"bcbs_partnerplan" |
	"bcbs_routinefootchk" |
	"bcbs_nonemergchk" |
	"bcbs_standardcopaycode" |
	"bcbs_faqtypecode" |
	"bcbs_numberoftiers" |
	"bcbs_flushotsagelimit" |
	"bcbs_gcseventtypeid" |
	"bcbs_relationshipprioritycode" |
	"bcbs_preferredretailtieroption" |
	"bcbs_reasonforquotecode" |
	null;

export const bcbs_fundingtypes = {
	"AdministrativeServicesOnly": {
		name: "Administrative Services Only",
		value: 808900000
	},
	"ASOwithStopLoss": {
		name: "ASO with Stop Loss",
		value: 808900001
	},
	"FullyInsured": {
		name: "Fully Insured",
		value: 808900002
	},
	"NationalAlliance": {
		name: "National Alliance",
		value: 808900003
	},
	"LevelFunded": {
		name: "Level Funded",
		value: 808900004
	},
}


// IXrmOptions.bcbs_groupconfigurationsnapshot
// TODO dont use this any more 
export const bcbs_lob = {
	"FEP": {
		name: "FEP",
		value: 808900006
	},
	"GI": {
		name: "G&I",
		value: 808900000
	},
	"StateGroup": {
		name: "State Group",
		value: 808900005
	},
	"MajorGroup": {
		name: "Major Group",
		value: 808900003
	},
	"NationalAlliance": {
		name: "National Alliance",
		value: 808900001
	},
	"BlueChoice": {
		name: "BlueChoice",
		value: 808900002
	},
	// bcbs_lob - Duplicate option set record, see details.
}

